import BlogHero from "@/components/blog/BlogHero";
import ImportantRead from "@/components/blog/ImportantRead";
import Layout from "@/components/layout/Layout";
import { cmsUrl } from "@/utils/helper";
import axios from "axios";
import { useEffect, useState } from "react";

const Blog = () => {
  const [blog, setBlog] = useState([]);
  const [latestImage, setLatestImage] = useState([]);
  const [category, setCategory] = useState([]);

  const getLatestThreeBlog = async () => {
    try {
      const res = await axios.get(
        `${cmsUrl}/wp-json/wp/v2/posts?per_page=3&page=1`
      );
      setBlog(res.data);
      const tempBlog = res.data;
      const combinedRequests = tempBlog.map(async (blog) => {
        const imageResponse = await axios.get(
          `${cmsUrl}/wp-json/wp/v2/media/${blog.featured_media}`
        );
        const categoryResponse = await axios.get(
          `${cmsUrl}/wp-json/wp/v2/categories/${blog.categories[0]}`
        );

        return {
          imageUrl: imageResponse.data.source_url,
          altText: imageResponse.data.alt_text,
          categoryName: categoryResponse.data.name,
        };
      });

      const combinedResponses = await window.Promise.all(combinedRequests);
      const latestImages = combinedResponses.map((item) => ({
        sourceUrl: item.imageUrl,
        alt_text: item.altText,
      }));
      const categories = combinedResponses.map((item) => item.categoryName);
      setLatestImage(latestImages);
      setCategory(categories);
    } catch (error) {
      console.error("Error fetching latest blogs:", error);
    }
  };

  useEffect(() => {
    getLatestThreeBlog();
  }, []);

  return (
    <Layout
      title="Latest Trends & Resources | Tech Development | ultroNeous Blog"
      description="Your one-stop place for the latest trends, updates, and news on Software, Web and Mobile Apps and Digital Marketing from ultroNeous Technologies."
    >
      <BlogHero blog={blog} latestImage={latestImage} category={category} />
      <ImportantRead />
    </Layout>
  );
};

export default Blog;
